import React, { useState } from "react";
import Navbar from "./Navbar";
import pdf from "../assets/pdf/MyResume.pdf";

const Header = () => {

  const [menu, setMenu] = useState(false);

  return (
    <header className="header-area formobile-menu header--transparent default-color">
      <div className={"header-wrapper" + (menu?" menu-open":"")} id="header-wrapper">
        <div className="header-left show-on-scroll">
          <div className="logo">
            <a href="#" id="Home0">
              <svg className="react-logo" xmlns="http://www.w3.org/2000/svg" width="1001.13" height="890.65" viewBox="0 0 1001.13 890.65">
                <linearGradient id="lg">
                  <stop stopColor="#f81f01" offset="0" />
                  <stop stopColor="#ee076e" offset="1" />
                </linearGradient>
                <circle className="react-logo__circle" cx="504.59" cy="444.48" r="89.57" fill="url(#lg)" />
                <path className="cls-2 react-logo__ring react-logo__ring--1" stroke="url(#lg)" d="M504.59,262.37c120.25,0,232,17.26,316.2,46.26,101.49,34.94,163.88,87.9,163.88,135.85,0,50-66.13,106.24-175.11,142.35-82.4,27.3-190.82,41.55-305,41.55-117,0-227.87-13.38-311.18-41.85-105.42-36-168.91-93-168.91-142,0-47.57,59.57-100.11,159.64-135C268.68,280,383.16,262.37,504.59,262.37Z" />
                <path className="cls-2 react-logo__ring react-logo__ring--2" stroke="url(#lg)" d="M346.06,354c60.07-104.17,130.83-192.32,198-250.81,81-70.46,158-98,199.56-74.1,43.29,25,59,110.36,35.83,222.81-17.52,85-59.34,186-116.37,284.95C604.64,638.18,537.69,727.51,471.4,785.45c-83.87,73.32-165,99.85-207.43,75.37-41.2-23.77-57-101.63-37.2-205.74C243.48,567.11,285.39,459.15,346.06,354Z" />
                <path className="cls-2 react-logo__ring react-logo__ring--3" stroke="url(#lg)" d="M346.21,537.06C286,433,244.92,327.66,227.82,240.23c-20.61-105.33-6-185.87,35.46-209.9,43.25-25,125.08,4,210.93,80.24C539.12,168.2,605.77,254.89,663,353.69,721.6,455,765.55,557.59,782.65,644c21.63,109.29,4.12,192.79-38.31,217.35-41.16,23.83-116.49-1.4-196.81-70.52C479.66,732.39,407.05,642.15,346.21,537.06Z" />
              </svg>
            </a>
          </div>
        </div>
        <div className="header-right">
          <Navbar close={()=>setMenu(false)} />
          <div className="header-btn show-on-scroll">
            <a
              className="rn-btn"
              href={pdf}
              target='_blank' rel='noopener noreferrer'
            >
              <span>Resume</span>
            </a>
          </div>
          <div className="humberger-menu d-block d-lg-none pl--20 show-on-scroll">
            <span className="menutrigger text-white" onClick={()=>{setMenu(true)}}>
              <svg
                stroke="currentColor"
                fill="none"
                strokeWidth="2"
                viewBox="0 0 24 24"
                strokeLinecap="round"
                strokeLinejoin="round"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <line x1="3" y1="12" x2="21" y2="12"></line>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <line x1="3" y1="18" x2="21" y2="18"></line>
              </svg>
            </span>
          </div>
          <div className="close-menu d-block d-lg-none">
            <span className="closeTrigger" onClick={()=>{setMenu(false)}}>
              <svg
                stroke="currentColor"
                fill="none"
                strokeWidth="2"
                viewBox="0 0 24 24"
                strokeLinecap="round"
                strokeLinejoin="round"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
